// HC section names look like "Artificial Intelligence (AI) Usage (XX)".
// The trailing `(XX)` is the code we render in the chip; everything before
// it (with the suffix stripped) is the display name.

export const extractSectionCode = (sectionName) => {
  if (!sectionName || typeof sectionName !== "string") return "??";
  const tail = sectionName.match(/\(([A-Z]{2,3})\)\s*$/);
  if (tail) return tail[1];
  const upper = sectionName.replace(/[^A-Z]/g, "");
  if (upper.length >= 2) return upper.slice(0, 2);
  const firstWord = sectionName.trim().split(/\s+/)[0] ?? "";
  return firstWord.slice(0, 2).toUpperCase() || "??";
};

export const cleanSectionName = (sectionName) => {
  if (!sectionName) return "";
  return sectionName.replace(/\s*\(([A-Z]{2,3})\)\s*$/, "").trim();
};
